/* eslint-disable react-hooks/rules-of-hooks */
import { useSelector } from 'react-redux';
import { ProjectNavigationNode } from '@pwc/pwc-deals-web-common';
import { getNavigation } from '../../features/project/projectSlice';

export const getNavigationTitle = (titleId: string) => {
  const navigationData: ProjectNavigationNode[] =
    useSelector(getNavigation) || [];

  const item = Array.isArray(navigationData)
    ? navigationData?.find((elem: ProjectNavigationNode) => elem.id === titleId)
    : '';
  return item ? item.title : '';
};
